module.exports = __webpack_public_path__ + "static/img/video_quiz_Photo.45a6cfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/video_quiz/video_quiz_Photo.png
// module id = xBIt
// module chunks = 1